import { useEffect, useRef } from 'react';
import lodashPkg from 'lodash';
const {throttle} = lodashPkg;

const ScrollProgressBar=()=>{
    const progressBarRef = useRef(null);

    useEffect(() => {
        const calculateScrollProgressbar = throttle(() => {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;
        if (progressBarRef.current) {
            progressBarRef.current.style.width = `${scrolled}%`;
        }
        }, 100); // Throttle execution to run at most every 100ms

        // Add scroll event listener
        window.addEventListener('scroll', calculateScrollProgressbar);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', calculateScrollProgressbar);
            calculateScrollProgressbar.cancel && calculateScrollProgressbar.cancel(); // Cancel throttled calls
        };
    }, []);

    return (
        <div className="progress-container h-1 fixed bottom-0 w-full">
            <div
                className="progress-bar h-full bg-deep-red w-0 transition-width duration-200"
                ref={progressBarRef}
            ></div>
        </div>
    );
}

export default ScrollProgressBar;